/* ROKI SHIPPING — banner, progress bar and cart shipping estimate.
   Reads window.RokiShipping (snippets/roki-shipping-config.liquid). No settings live in this file.

   The <roki-cart-shipping> element is used twice in the cart:
     - snippets/roki-cart-shipping.liquid  -> progress bar (top of the drawer)
     - snippets/roki-cart-estimate.liquid  -> estimated shipping + estimated total (under Subtotal)
   Each copy only fills in the parts it contains. */
(function () {
  'use strict';
  var C = window.RokiShipping;
  if (!C) return;

  /* Shopify's live AUD -> shopper-currency rate (1 when shopping in AUD). */
  function fxRate() {
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return r && r > 0 ? r : 1;
  }
  function currency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || C.currency || 'AUD';
  }
  function fmt(amount, decimals) {
    try {
      return new Intl.NumberFormat(C.locale || undefined, {
        style: 'currency', currency: currency(), currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: decimals, maximumFractionDigits: decimals
      }).format(amount);
    } catch (e) { return currency() + ' ' + amount.toFixed(decimals); }
  }
  /* Exact threshold in shopper currency, in cents (matches what checkout uses). */
  function thresholdCents() { return Math.round(C.thresholdAUD * 100 * fxRate()); }
  /* Banner number: rounded UP so the promise is never broken. */
  function roundedThreshold() {
    var v = C.thresholdAUD * fxRate();
    var step = v < 1000 ? 5 : (v < 10000 ? 50 : 500);
    return Math.ceil(v / step - 1e-9) * step;
  }
  function zoneFor(country) {
    if (country === 'AU' || country === 'CA') return country;
    for (var key in C.zones) {
      var list = C.zones[key].countries;
      if (list && list.indexOf(country) !== -1) return key;
    }
    return 'ROW';
  }

  /* Both cart blocks ask for the cart at the same moment: share one request. */
  var pending = null;
  function getCart() {
    if (!pending) {
      pending = fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', {
        credentials: 'same-origin', headers: { Accept: 'application/json' }
      }).then(function (r) { return r.json(); });
      pending.then(function () { pending = null; }, function () { pending = null; });
    }
    return pending;
  }

  /* 1) Announcement-bar banner */
  class RokiFreeShippingBanner extends HTMLElement {
    connectedCallback() {
      this.textContent = 'Free worldwide shipping over ' + fmt(roundedThreshold(), 0);
    }
  }

  /* 2) Progress bar and 3) estimated shipping (re-reads the cart on every cart change) */
  class RokiCartShipping extends HTMLElement {
    connectedCallback() {
      this.refresh = this.refresh.bind(this);
      this.refresh();
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
        this.unsub = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, this.refresh);
      }
      document.addEventListener('cart:updated', this.refresh);
    }
    disconnectedCallback() {
      if (this.unsub) this.unsub();
      document.removeEventListener('cart:updated', this.refresh);
    }
    refresh() {
      var self = this;
      getCart().then(function (cart) { self.render(cart); }).catch(function () {});
    }
    render(cart) {
      if (!cart.item_count) { this.hidden = true; return; }
      this.hidden = false;

      var total = cart.total_price;                 /* cents, shopper currency, after discounts */
      var limit = thresholdCents();
      var free = total >= limit;
      var hasHQ = false, hasDeyi = false;
      (cart.items || []).forEach(function (it) {
        if (C.hqHandles.indexOf(it.handle) !== -1) hasHQ = true; else if (it.requires_shipping) hasDeyi = true;
      });
      this.classList.toggle('is-unlocked', free);

      /* --- Progress bar (top of drawer) --- */
      var bar = this.querySelector('[data-roki-bar]');
      var msg = this.querySelector('[data-roki-msg]');
      if (bar) bar.style.width = Math.max(0, Math.min(100, (total / limit) * 100)).toFixed(1) + '%';
      if (msg) {
        msg.textContent = free ? 'Free shipping unlocked'
          : fmt((limit - total) / 100, 2) + ' away from free shipping';
      }

      /* --- Shipping estimate (under Subtotal) --- */
      var est = this.querySelector('[data-roki-est]');
      if (!est) return;
      var note = this.querySelector('[data-roki-note]');
      var totalRow = this.querySelector('[data-roki-total-row]');
      var totalEl = this.querySelector('[data-roki-total]');
      var shipping = null;                          /* shopper currency; null = only known at checkout */

      if (free) {
        shipping = 0;
        est.textContent = 'FREE';
      } else if (!hasDeyi) {
        est.textContent = 'Calculated at checkout'; /* Roki HQ items only: AusPost needs the full address */
      } else {
        var aud = total / 100 / fxRate();           /* cart value back in AUD for the band check */
        var band = aud < C.band2FromAUD ? 0 : (aud < C.band3FromAUD ? 1 : (aud < C.band4FromAUD ? 2 : 3));
        shipping = C.zones[zoneFor(C.country)].rates[band] * fxRate();
        est.textContent = fmt(shipping, 2) + (hasHQ ? ' + AusPost' : '');
      }

      est.classList.toggle('is-muted', shipping === null);
      if (note) note.hidden = !(hasHQ && hasDeyi && !free);
      if (totalRow) totalRow.hidden = shipping === null;
      if (totalEl && shipping !== null) {
        totalEl.textContent = (hasHQ && !free ? 'From ' : '') + fmt(total / 100 + shipping, 2) + ' ' + currency();
      }
    }
  }

  if (!customElements.get('roki-free-shipping-banner')) customElements.define('roki-free-shipping-banner', RokiFreeShippingBanner);
  if (!customElements.get('roki-cart-shipping')) customElements.define('roki-cart-shipping', RokiCartShipping);
})();
